import { SearchItem } from './module';

export const SymbolModuleId = 'Symbol' as const;

//Legacy

//V1
export interface SymbolSearchItemDataV1 {
  symbol: string;
  label: string;
  isTrending?: boolean;
}

export const SymbolSearchItemVersionV1 = '1' as const;

export interface SymbolSearchItemV1 extends SearchItem<SymbolSearchItemDataV1> {
  version: typeof SymbolSearchItemVersionV1;
  moduleId: typeof SymbolModuleId;
}

export type LegacySymbolSearchItem = SymbolSearchItemV1;

// Current

export type SymbolSearchItemData = SymbolSearchItemDataV1;

export const SymbolSearchItemVersion = SymbolSearchItemVersionV1;

export type SymbolSearchItem = SymbolSearchItemV1;

export const SymbolItemSpecifier = '$';

export const createSymbolSearchItem = (tagId: string, label?: string, isTrending?: boolean): SymbolSearchItem => ({
  data: {
    isTrending,
    label: label ?? '',
    symbol: tagId,
  },
  id: tagId,
  moduleId: SymbolModuleId,
  version: SymbolSearchItemVersion,
});

export const isLegacySymbolSearchItem = (item: SearchItem): item is LegacySymbolSearchItem =>
  item?.moduleId === SymbolModuleId;

export const isSymbolSearchItem = (item: SearchItem): item is SymbolSearchItem =>
  item?.moduleId === SymbolModuleId && item?.version === SymbolSearchItemVersion;
